module.exports = __webpack_public_path__ + "img/directors.4fdd212d.svg";